import type { ITCFConsent, ITCFVendorCategory } from "../TCFConsentProvider/types";

const isTCFCategoryLegitimateInterestAccepted = (
  name: ITCFVendorCategory,
  id: number,
  tempConsent: ITCFConsent,
): boolean => {
  // Check if category is already accepted. Its structured like this to prevent trying to read "[id]" of undefined
  return !!(tempConsent.categoriesLegitimateInterest[name] || {})[id];
};

export default isTCFCategoryLegitimateInterestAccepted;
